import { useTranslation } from 'react-i18next';
import { Frequency } from '@amzn/taskscheduling-service';

// FrequencyOption only requires value
export type FrequencyOption = Frequency;

// Return type includes label but doesn't require it in FrequencyOption type
export const useFrequency = () => {
  const { t } = useTranslation();
  return [
    { label: t('daily'), value: Frequency.DAILY },
    { label: t('monthly'), value: Frequency.MONTHLY },
  ];
};
